<section class="br-card">
  <header class="br-card-header br-flex br-items-center br-justify-between br-gap-3">
    <h1 class="workspace-page__title">Follow-ups</h1>
    <div class="calendar-nav" aria-label="Calendar navigation">
    <button type="button"
            class="br-btn br-btn--ghost br-btn--sm br-icon-btn"
            (click)="prevMonth()"
            matTooltip="Previous month"
            aria-label="Previous month">
      <br-icon>chevron_left</br-icon>
    </button>
    <span class="month-label" aria-live="polite">{{ monthLabel }}</span>
    <button type="button"
            class="br-btn br-btn--ghost br-btn--sm br-icon-btn"
            (click)="nextMonth()"
            matTooltip="Next month"
            aria-label="Next month">
      <br-icon>chevron_right</br-icon>
    </button>
    <button type="button"
            class="br-btn br-btn--outline-secondary br-btn--sm"
            (click)="goToday()">
      Today
    </button>
    </div>
  </header>

  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

  <div class="br-card-body follow-up-content">
    <div class="calendar-scroll">
      <div class="calendar">
        <div class="cal-head">
          <div class="cal-dow" *ngFor="let d of weekdays">{{ d }}</div>
        </div>
        <div class="cal-week" *ngFor="let week of weeks">
          <div class="cal-cell" *ngFor="let cell of week"
               [class.other-month]="!cell.inMonth"
               [class.is-today]="cell.isToday"
               [class.selected]="selected && selected.iso === cell.iso"
               (click)="selectDay(cell)">
            <div class="cell-date">{{ cell.date.getDate() }}</div>
            <div class="cell-items">
              <div class="pip" *ngFor="let it of cell.items.slice(0, 3)"
                   [class.overdue]="cell.isPast"
                   [matTooltip]="it.customerName + ' — ' + it.subject + '  (open Interaction Tracking)'"
                   (click)="goToCustomer(it.customerId); $event.stopPropagation()">
                {{ it.customerName }}
              </div>
              <div class="more" *ngIf="cell.items.length > 3">+{{ cell.items.length - 3 }} more</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section class="agenda br-card" *ngIf="selected">
      <header class="br-card-header agenda-header">
        <h2 class="br-card-title">{{ selected.date | date:'fullDate' }}</h2>
        <span class="br-small br-text-muted">
          {{ selected.items.length }} {{ selected.items.length === 1 ? 'follow-up' : 'follow-ups' }}
        </span>
      </header>
      <div class="agenda-list">
        <div class="agenda-item" *ngFor="let it of selected.items">
          <div class="ai-main">
            <div class="ai-heading">
              <button type="button"
                      class="br-btn br-btn--link br-btn--sm ai-customer"
                      (click)="goToCustomer(it.customerId)">
                {{ it.customerName }}
              </button>
              <span class="br-badge ai-chip">{{ it.activityType }}</span>
            </div>
            <div class="ai-subject">{{ it.subject }}</div>
          </div>
          <button type="button"
                  class="br-btn br-btn--primary br-btn--sm"
                  *ngIf="auth.hasPermission('Customer.Manage')"
                  (click)="complete(it)">
            <br-icon>check</br-icon>
            Mark done
          </button>
        </div>
      </div>
    </section>
  </div>
</section>
